const state = {
  barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
  barImage: "",
  drawer: null,
  options: {
    app_name: "Jugenddienst"
  }
};
const mutations = {
  SET_BAR_IMAGE(state, payload) {
    state.barImage = payload;
  },
  SET_DRAWER(state, payload) {
    state.drawer = payload;
  },
  SET_SCRIM(state, payload) {
    state.barColor = payload;
  },
  SET_OPTIONS(state, payload) {
    state.options = payload;
  }
};

export default {
  modules: {
    mutations,
    state
  }
};
